module.exports = __webpack_public_path__ + "img/download-white.ea33a5a2.svg";